// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));

//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})

// Notif popup parameters 
const notifPopup = document.querySelector('.notif-popup');
const notifPopupClose = document.querySelector('.notif-popup__close');
const notifPopupNone = document.querySelector('.notif-popup__button--none');
const notifPopupLink = document.querySelector('.notif-popup__button--link');

const notifStorage = localStorage.getItem('notif');

if(!localStorage.getItem('notif')) {
    notifPopup.classList.remove('notif-popup--hidden');
    notifPopup.classList.remove('notif-popup--close');
}

function closeNotifBanner() {
    localStorage.setItem('notif', 'close');
    setTimeout(() => {
        notifPopup.classList.add('notif-popup--close');
    }, 500);

    setTimeout(() => {
        notifPopup.classList.add('notif-popup--hidden');
    }, 2500);
}

notifPopupClose.addEventListener('click', closeNotifBanner, false);
notifPopupNone.addEventListener('click', closeNotifBanner, false);
notifPopupLink.addEventListener('click', closeNotifBanner, false);

// Map settings
const citiesMap = document.querySelectorAll('.map .map__image svg a');
const cities = Array.from(document.querySelectorAll('.map .map__cities .map__city-name'));

if(window.screen.width > 960) {

    citiesMap.forEach(cityMap => {
        cityMap.addEventListener("mouseover", () => hoverCityMap(cityMap));
        cityMap.addEventListener("mouseout", () => leaveCityMap(cityMap)); // Gestionnaire pour supprimer la classe
    });

    cities.forEach(city => {
        city.addEventListener("mouseover", () => hoverCity(city));
        city.addEventListener("mouseout", () => leaveCity(city));
    });

    function hoverCityMap(cityMap) {
        const cityNameMap = cityMap.getAttribute('data-title').toLowerCase();

        const result = cities.find(city => city.innerText.toLowerCase().includes(cityNameMap));

        if (result) {
            result.parentNode.parentNode.classList.add('map__city--hover');
        } else {
            console.warn(`Aucune correspondance trouvée pour: ${cityNameMap}`);
        }
    }

    function leaveCityMap(cityMap) {
        const cityNameMap = cityMap.getAttribute('data-title').toLowerCase();

        const result = cities.find(city => city.innerText.toLowerCase().includes(cityNameMap));

        if (result) {
            result.parentNode.parentNode.classList.remove('map__city--hover'); // Supprimer la classe
        } else {
            console.warn(`Aucune correspondance trouvée pour: ${cityNameMap}`);
        }
    }

    function hoverCity(city) {
        const cityName = city.innerText.toLowerCase();

        const result = Array.from(citiesMap).find(cityMap => cityMap.getAttribute('data-title').toLowerCase().includes(cityName));

        if (result) {
            result.classList.add('map__image--hover'); // Ajout de la classe sur cityMap
        } else {
            console.warn(`Aucune correspondance trouvée pour: ${cityName}`);
        }
    }

    function leaveCity(city) {
        const cityName = city.innerText.toLowerCase();

        const result = Array.from(citiesMap).find(cityMap => cityMap.getAttribute('data-title').toLowerCase().includes(cityName));

        if (result) {
            result.classList.remove('map__image--hover'); // Suppression de la classe sur cityMap
        } else {
            console.warn(`Aucune correspondance trouvée pour: ${cityName}`);
        }
    }

}

const blocsPictures = document.querySelectorAll('.pictures .bloc__wrapper--image');

document.addEventListener('DOMContentLoaded', () => {
    console.log(blocsPictures);
});

blocsPictures.forEach(blocPicture => {
    blocPicture.addEventListener('mouseenter', () => {
        console.log("L'element est survolé");
    });
});

